import script from "./ElaComputers.vue?vue&type=script&setup=true&lang=js"
export * from "./ElaComputers.vue?vue&type=script&setup=true&lang=js"

import "./ElaComputers.vue?vue&type=style&index=0&id=077ab7c2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077ab7c2"]])

export default __exports__